import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import React, { useRef, useEffect, useState } from 'react';
import Slide from '@mui/material/Slide';
import { Tooltip, tooltipClasses } from '@mui/material';

const compareValue = {
    l_eq_r: "Left = Right",
    l_gt_r: "Left > Right",
    l_lt_r: "Left < Right"
}

const colorCode = {
    "numbing": "green",
    "shooting": "fill-red-600",
    "shooting/sharp": "fill-red-600",
    "tingling": "cyan",
    "constant": "fill-red-400",
    "intermittent": "fill-purple-400",
    "whenflexing": "fill-orange-400",
    "whenlyingflat": "fill-rose-300",
    "numbing_bg": "bg-green-700",
    "shooting_bg": "bg-red-600",
    "shooting/sharp_bg": "bg-red-600",
    "tingling_bg": "bg-cyan-300",
    "constant_bg": "bg-red-400",
    "intermittent_bg": "bg-purple-400",
    "whenflexing_bg": "bg-orange-400",
    "whenlayingflat_bg": "bg-rose-300",
    "numbing_border": "border-green-700 border-4",
    "tingling_border": "border-cyan-300 border-4",
}
export function useIsMounted() {
    const isMounted = useRef(false);

    useEffect(() => {
        isMounted.current = true;
        return () => isMounted.current = false;
    }, []);

    return isMounted;
}
export function getColorCode(pain) {
    if (pain) {
        const painName = pain.replace(/\s+/g, '').toLowerCase(); 
        return colorCode[painName]
    } else {
        return 'fill-gray-300'
    }
}

export function labelToTitleCase(label) {
}


export function setLocalstorage(key, value) {
    return localStorage.setItem(key, value);
}
export function getLocalstorage(key) {
    return localStorage.getItem(key);
}
export function inSentenceCase(name) {
    if (name) {
        const arr = name.split('_');
        const string1 = arr.join(" ");
        const arr1 = string1.split('@');
        let string2 = arr1[0];
        if (arr1[1]) {
            string2 = string2 + ': ' + arr1[1]
        }
        return string2;
    } else {
        return ''
    }
}

export function getSliceName(name) {
    if (name) {
        const arr = name.split('_');
        const string1 = arr.join(" ");
        const arr1 = string1.split('@');
        const dataSplit = arr1[0].split(',')
        return dataSplit;
    } else {
        return ''
    }
}

export function getValueOfSlice(name) {
    if (name) {
        const arr1 = name.split('@');
        return arr1[1];
    } else {
        return ''
    }
}

export function getNameAfterSplit(key, splitConst, index) {
    if (key) {
        const arr = key.split(splitConst);
        return arr[index];
    } else {
        return ''
    }
}

export function mapCoordinate(numb) {
    return Math.trunc(Number(numb) / 3.375)
}


export function formatDisc(name) {
    if (name) {
        const arr = name.split('_');
        const string1 = arr.join("-");
        return string1;
    } else {
        return ''
    }
}

export function formatCompareString(name) {
    if (name) {
        return compareValue[name];
    } else {
        return ''
    }
}

export const PrettoSlider = styled(Slider)({
    color: '#002E98',
    height: 8,
    '& .MuiSlider-track': {
        border: 'none',
    },
    '& .MuiSlider-thumb': {
        height: 18,
        width: 18,
        backgroundColor: '#fff',
        border: '2px solid currentColor',
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&:before': {
            display: 'none',
        },
    },
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: 10,
        background: 'unset',
        padding: 0,
        width: 35,
        height: 35,
        borderRadius: '50% 50% 50% 0',
        backgroundColor: '#002E98',
        transformOrigin: 'bottom left',
        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
        '&:before': { display: 'none' },
        '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
        },
        '& > *': {
            transform: 'rotate(45deg)',
        },
    },
});

export const IOSSlider = styled(Slider)(({ theme }) => ({
    color: theme.palette.mode === 'dark' ? '#3880ff' : '#3880ff',
    height: 2,
    padding: '15px 0',
    '& .MuiSlider-thumb': {
        height: 28,
        width: 28,
        backgroundColor: '#fff',
        boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)',
        '&:focus, &:hover, &.Mui-active': {
            boxShadow:
                '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)',
            },
        },
    },
    '& .MuiSlider-valueLabel': {
        fontSize: 12,
        fontWeight: 'normal',
        top: -6,
        backgroundColor: 'unset',
        color: theme.palette.text.primary,
        '&:before': {
            display: 'none',
        },
        '& *': {
            background: 'transparent',
            color: theme.palette.mode === 'dark' ? '#fff' : '#000',
        },
    },
    '& .MuiSlider-track': {
        border: 'none',
    },
    '& .MuiSlider-rail': {
        opacity: 0.5,
        backgroundColor: '#bfbfbf',
    },
    '& .MuiSlider-mark': {
        backgroundColor: '#bfbfbf',
        height: 8,
        width: 1,
        '&.MuiSlider-markActive': {
            opacity: 1,
            backgroundColor: 'currentColor',
        },
    },
}));


export const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.mode === 'dark' ? '#002E98' : '#002E98',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 12,
        height: 12,
        borderRadius: 6,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor:
            theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
        boxSizing: 'border-box',
    },
}));

export const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const tourOptions = {
    defaultStepOptions: {
        cancelIcon: {
            enabled: true
        }
    },
    useModalOverlay: true
};

export const SliceEnum = {
    AXIAL_DISK_BEAKING_CLASSFICATION_BEAKED: 'AXIAL_DISK_BEAKING_CLASSFICATION_BEAKED',
    AXIAL_DISK_BEAKING_CLASSFICATION_CURVED: 'AXIAL_DISK_BEAKING_CLASSFICATION_CURVED',
    AXIAL_DISK_BEAKING_CLASSFICATION_FLATTENED: 'AXIAL_DISK_BEAKING_CLASSFICATION_FLATTENED',
    DISK_INTERNAL_SEGMENTATION_RESULT: 'DISK_INTERNAL_SEGMENTATION_RESULT',
    FORAMIN_STENOSIS_CLASSFICATION_WITH_SALIENCY_MAPS: 'FORAMIN_STENOSIS_CLASSFICATION_WITH_SALIENCY_MAPS',
    HIZ_REGIONS_FILTERED: 'HIZ_REGIONS_FILTERED',
    STENOSIS_CLASSFICATION_SAGITTAL_STENOSIS_0: 'STENOSIS_CLASSFICATION_SAGITTAL_STENOSIS_0',
    STENOSIS_CLASSFICATION_SAGITTAL_STENOSIS_1: 'STENOSIS_CLASSFICATION_SAGITTAL_STENOSIS_1',
    SAGITTAL_SEGMENTATION_RESULT_MEDICAL_MODEL: 'SAGITTAL_SEGMENTATION_RESULT_MEDICAL_MODEL',
    AXIAL_SEGMENTATION_RESULT_MEDICAL_MODEL: 'AXIAL_SEGMENTATION_RESULT_MEDICAL_MODEL',
};


export function clearLocalStrorage() {
    const val = getLocalstorage('onborading');
    localStorage.clear();

    setLocalstorage('onborading', val)
}

export const useFormInput = (initialValue) => {
    const [value, setValue] = useState(initialValue);
    const handleChange = (e) => {
        setValue(e.target.value);
    }
    return {
        value,
        onChange: handleChange
    }
}


export const LocalTooltip = styled(({ className, ...props }) => (

    <Tooltip {...props} classes={{ popper: className }} PopperProps={{
        disablePortal: true
    }}
        onClose={props.handleTooltipClose}
        disableFocusListener
        disableHoverListener
        disableTouchListener />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));
